import Image from 'next/image';
import React from 'react';
import { Typography } from '../common';

export const ModalAlreadyActiveAccountContent = () => {
	return (
		<>
			<div className="flex items-center justify-center w-full gap-2 mb-10">
				<Image
					src={'/logos/hat-logo.png'}
					alt=""
					width={40}
					height={40}
					className="hidden md:block"
					priority
					quality={75}
				/>
				<Typography type="semibold-20">Your Account is Reactivated</Typography>
			</div>
			<Typography type="regular-16">
				Your account is already reactivated.
			</Typography>
			<Typography type="regular-16">No further action is needed.</Typography>
		</>
	);
};
